import { Box, Typography } from '@mui/material';
import React from 'react';
import { SensordataNewestMixed } from '../../../redux/monitoring/api/monitoring.model';
import { getPolyglot } from '../../../i18n';
import { useCurrentStateByControlUnitId } from '../../../redux/controlUnit/hooks/useCurrentStateByControlUnitId';
import usePreferredTemperatureUnit from '../../../redux/settings/hooks/usePreferredTemperatureUnit';
import { getValueWithPreferredUnitAndDecimals } from '../../../redux/controlUnit/api/util/sensor/formatValues';

const DISABLED_TEXT = '-- / --';
interface SensorProps {
  icon: React.ReactElement;
  sensorName: string;
  on: boolean | undefined;
  value: SensordataNewestMixed | undefined;
  setpoint?: SensordataNewestMixed | undefined | null;
  CUTranslate: ReturnType<typeof useCurrentStateByControlUnitId>['CUTranslate'];
}
function Sensor(props: SensorProps) {
  const { icon, on, value, setpoint, CUTranslate } = props;
  const { data: preferredTemperatureUnit } = usePreferredTemperatureUnit();
  const { strValue: valueUnit } = getValueWithPreferredUnitAndDecimals(
    value?.value,
    value?.metadata?.unitString ?? value?.metadata?.unit,
    value?.metadata?.decimals,
    preferredTemperatureUnit
  );

  const { strValue: setpointUnit } = getValueWithPreferredUnitAndDecimals(
    setpoint?.value,
    setpoint?.metadata?.unitString ?? setpoint?.metadata?.unit,
    setpoint?.metadata?.decimals,
    preferredTemperatureUnit
  );

  // FIXME: use correct values from temperature
  const valueText = !value?.value ? '--' : valueUnit;
  const setpointText =
    setpoint === null ? '' : `/ ${!setpoint?.value ? '--' : setpointUnit}`;

  const name =
    (value?.metadata?.id && (CUTranslate(value?.metadata?.id) as string)) ||
    value?.metadata?.name;
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      padding={1}
    >
      <Box padding={0.2}>{icon}</Box>
      <Box display={'flex'} flexDirection={'column'} ml={1}>
        <Typography variant="body1" fontSize="0.8em">
          {name}
        </Typography>
        <Typography color="#2A2A2B" fontSize="1.5em">
          {on ? `${valueText} ${setpointText}` : DISABLED_TEXT}
        </Typography>
      </Box>
    </Box>
  );
}

export default Sensor;
